import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { pricePlanCalc } from "../../../../services/utils";
import { InfoToolTip } from "../../../../components";

export default function PlanColumn({
  plan,
  selectPlan,
  subscriptionType,
  organizationCredits,
  isSimulator,
}) {
  const [currentPlan, setCurrentPlan] = useState(plan);
  const [current, setCurrent] = useState(null);
  const intl = useIntl();
  useEffect(() => {
    let thisPlan = { ...plan };
    if (subscriptionType === "yearly") {
      thisPlan.yearly = true;
    } else {
      thisPlan.yearly = false;
    }
    setCurrentPlan(thisPlan);
    if (organizationCredits) {
      setCurrent(
        organizationCredits.plan.numberOfMonths == 12 &&
          organizationCredits.plan.planId == thisPlan.planId &&
          thisPlan.yearly == true
          ? true
          : organizationCredits.plan.numberOfMonths !== 12 &&
            organizationCredits.plan.planId == thisPlan.planId &&
            thisPlan.yearly == false
          ? true
          : false
      );
    }
  }, [subscriptionType, plan]);
  if (!currentPlan) return <div />;

  return (
    <Col md={4}>
      <div className="subcription-plan-ui">
        <h4
          className={
            "title " + (currentPlan.planId == "plan_2" ? "pink" : "blue")
          }
        >
          {currentPlan.name}
        </h4>
        {!isSimulator && (
          <p className="subtitle">
            {currentPlan.planId == "plan_1" ? (
              <FormattedMessage id={"billing.perfectForSmallTeams"} />
            ) : (
              <FormattedMessage id={"billing.perfectForGrowth"} />
            )}
          </p>
        )}
        {isSimulator && plan.notAvailable ? (
          <div
            style={{
              margin: "70px 0",
              padding: 15,
              borderRadius: 10,
              color: "#999",
              textAlign: "center",
            }}
          >
            <div className={"plan-not-available"}>
              <FormattedMessage id={"billing.notAvailable"} />
            </div>
          </div>
        ) : (
          <div>
            <p className="price-text">
              <span>
                {pricePlanCalc({
                  price: currentPlan.pricePerSeat,
                  yearly: currentPlan.yearly,
                })}
                €
              </span>
              <FormattedMessage id={"billing.excludingTax"} />{" "}
              {isSimulator ? (
                <>
                  <FormattedMessage id={"billing.month"} />
                </>
              ) : (
                <FormattedMessage id={"billing.userMonth"} />
              )}
              {isSimulator && currentPlan.yearly && (
                <small className={"simulator_total_amount"}>
                  ( <FormattedMessage id={"billing.annualAmount"} />:{" "}
                  <strong>
                    {pricePlanCalc({
                      price: currentPlan.pricePerSeat,
                      yearly: currentPlan.yearly,
                      perYear: true,
                    })}
                  </strong>
                  € )
                </small>
              )}
            </p>
            <p className="credit-text-ui">
              {currentPlan.creditsPerSeat} <FormattedMessage id={"credits"} />{" "}
              <span>
                {" "}
                {isSimulator ? (
                  <>
                    /<FormattedMessage id={"billing.month"} />
                    <span
                      style={{
                        float: "right",
                        color: "#555",
                        fontSize: 17,
                        marginRight: 10,
                      }}
                    >
                      {plan.numberOfSeats !== 1
                        ? "1-" + plan.numberOfSeats
                        : plan.numberOfSeats}{" "}
                      <FormattedMessage id={"billing.users"} />
                    </span>
                  </>
                ) : (
                  <FormattedMessage id={"billing.userMonth"} />
                )}
              </span>
            </p>
            {current ? (
              <a className="btn2">
                {" "}
                <FormattedMessage id={"billing.currentPlan"} />
              </a>
            ) : (
              <a className="btn1" onClick={() => selectPlan(currentPlan)}>
                <FormattedMessage id={"billing.choosePlan"} />
              </a>
            )}
          </div>
        )}

        <ul className="permissions">
          <li>
            {" "}
            <FormattedMessage id={"billing.contactSearch"} />
          </li>
          <li>
            <FormattedMessage id={"billing.contactManagement"} />
          </li>
          {/* {plan.permissions.map((permission, i) => (
            <li key={i}>{permission.name}</li>
          ))}*/}
          <li>
            <FormattedMessage id={"billing.exportingContact"} />
          </li>
          <li
            style={{
              textDecoration:
                currentPlan.planId === "plan_1" ? "line-through" : "",
            }}
          >
            <FormattedMessage id={"billing.crmIntegration"} />
          </li>
          <li
            style={{
              textDecoration:
                currentPlan.planId === "plan_1" ? "line-through" : "",
            }}
          >
            <FormattedMessage id={"billing.salesAutomation"} />{" "}
            {currentPlan.planId == "plan_2" && (
              <InfoToolTip
                text={intl.formatMessage({
                  id: "billing.salesAutomationTextInfo",
                })}
              />
            )}
          </li>
          <li>
            {" "}
            <FormattedMessage id={"billing.statisticsAndPerformance"} />
          </li>
          <li>
            {" "}
            <FormattedMessage id={"billing.teamManagement"} />
          </li>
          <li>
            <FormattedMessage id={"billing.24x7CustomerSupport"} />
          </li>
          <li>
            <FormattedMessage id={"billing.perUserSettings"} />{" "}
            <p>
              <small>
                <FormattedMessage id={"billing.creditsAllotment"} />
              </small>
            </p>
          </li>
        </ul>
      </div>
    </Col>
  );
}
